import { render, staticRenderFns } from "./ClaimTopPromotionWidget.vue?vue&type=template&id=c5052dd8"
import script from "./ClaimTopPromotionWidget.vue?vue&type=script&lang=js"
export * from "./ClaimTopPromotionWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports